<!-- eslint-disable no-debugger -->
<!-- eslint-disable no-debugger -->
<!-- eslint-disable no-debugger -->
<!--图像列表展示 --- 瀑布流结构  -->
<template>
  <div id="imgBoxListPan">
    <div id="typeCanvas" style="height:40px; width:100%;">
      <div id="typename">{{ typeName }}</div>
      <div id="searchRsCount">共找到 {{ searchRsCount }} 幅</div>
    </div>
    <div id="imgBoxList">
      <div v-show="isNoResult" id="resInfo">没有找到图像 ......</div>
      <el-scrollbar id="sbar" v-show="!isNoResult" ref="myScrollbar">
        <div class="rowPan">

      <div class="i_box"
        v-for="(ibean, index) in totalSwImgs"
        :key="ibean.id"
      >
        <imgbox @saveResultState="saveResultState"
          :iHeight="destHeight"
          :id="ibean.id"
          :iname="ibean.iname"
          :isrc="ibean.isrc"
          :idraw="ibean.idraw"
          :imark="ibean.imark"
          :pos="ibean.pos"
          :len="ibean.len"
          :posSrc="ibean.posSrc"
          :lenSrc="ibean.lenSrc"
          :label="ibean.label"
          :level="ibean.level"
          :iClass="ibean.iClass"
          :titleG="ibean.titleG"
          :clearBG="ibean.clearBG"
          :boxRole="rowRole"
          :maker="ibean.maker"
          :arrayPos = index
          :publishTime="ibean.iclass1"
        ></imgbox>
        </div>

        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import imgbox from './rely/rely/iBoxInInRow'
export default {
  emits: ['beginSearch'],
  mounted () {
    // eslint-disable-next-line no-debugger
    debugger

    this.totalSwImgs = this.$store.state.globalObj.swImgs
    if (this.totalSwImgs !== null && this.totalSwImgs.length > 0) {
      this.totalPages = this.$store.state.globalObj.totalPage
      this.currentPage = this.$store.state.globalObj.currPageNo
      this.searchRsCount = this.$store.state.globalObj.totalResult
      this.scrollTop = this.$store.state.globalObj.scrollTop

      this.searchKey = this.$store.state.globalObj.searchKeyWords

      // 在此把 myScrollbar 滑块的位置调整为scrollTop
      // 使用$nextTick确保DOM已经渲染完毕
      /*
      setTimeout(() => {
        if (this.$refs.myScrollbar) {
          this.$refs.myScrollbar.wrap.scrollTop = this.scrollTop
        }
      }, 400)
     */
      // 使用$nextTick确保DOM已经渲染完毕 这个比settimeout 更丝滑
      this.$nextTick(() => {
        if (this.$refs.myScrollbar && this.$refs.myScrollbar.wrap) {
          this.$refs.myScrollbar.wrap.scrollTop = this.scrollTop
        }
      })
    } else {
      this.jump2Search() // 第一次加载 检索列表页 执行检索 用此方法
    }

    this.handleScorll()
  },
  data () {
    return {
      currentPage: 1,
      totalitems: 0,
      totalPages: 0,
      pageSize: 50,
      swImgs: [],
      totalSwImgs: [],
      swImgsOnlyShowName: [], // 用来保存只显示图名的结果集 // 只显示图名的方式已全部去除
      searchKey: '',
      typeClass: '',
      isNoResult: false,
      rowsArray: [], // 木桶显示保存数组
      lastRow: [], // 不止一页的情况下 非最后一页最后一行显示可能会缺部分，这时候不显示他等翻页的时候再把它加进去
      rebackCount: 0, // 木桶显示的话最后一行可能不能占满行 所以这页就不显示了，下次请求其实号就往回缩几张 0：不回缩  N:缩N张图
      isLoading: false,
      newReSearch: true, // 是否是重新点击分类或者关键词检索， 是的话就把 this.columnArray 清空
      searchRsCount: 0, // 总结果个数
      typeName: '',
      scrollTop: 0
    }
  },
  methods: {
    // 点击缩微图进入大图触发
    saveResultState () {
      // 给全局对象赋值
      // eslint-disable-next-line no-debugger
      debugger
      this.$store.commit('setGlobalTotalPage', this.totalPages)
      this.$store.commit('setGlobalCurrPageNo', this.currentPage)
      this.$store.commit('setGlobalTotalResult', this.searchRsCount)
      this.$store.commit('setGlobalScrollTop', this.scrollTop)

      this.$store.commit('setGlobalObjOfSearchKeyWords', this.searchKey)
    },
    /**
     * 当滚轮滚动的时候自动判断是否需要重新请求
     */
    handleScorll () {
      // 监听滚动条状态
      const _self = this
      const scrollbarEl = this.$refs.myScrollbar.wrap
      scrollbarEl.onscroll = function () {
        const viewHeight = scrollbarEl.firstChild.clientHeight // 内容区高度
        const viewportHeight = scrollbarEl.clientHeight // 视窗高度
        const ppb = scrollbarEl.scrollTop
        // eslint-disable-next-line no-debugger
        // debugger
        _self.scrollTop = ppb
        const marginBottom = viewHeight - viewportHeight - ppb
        // let harfHeight = viewportHeight / 2
        if (marginBottom < viewportHeight) {
          if (!_self.isLoading) {
            // console.log('读取下页数据...')
            if (_self.currentPage < _self.totalPages) {
              _self.newReSearch = false // 还有数据 则设为false 让请求的新数据补充到显示数组中
              _self.isLoading = true // 把当前状态设为正在加载中
              _self.currentPage++

              _self.searchImages(
                _self.searchKey,
                _self.typeClass,
                _self.currentPage,
                _self.pageSize
              )
            } else {
              _self.newReSearch = true // 没有数据了则设为true  让新请求（重新点分类或检索词）的新数据覆盖至新的数据
            }
          }
        }

        // console.log(ppb)
        // console.log('view_height:' + viewHeight)
      }
    },
    toTop () {
      this.$refs.myScrollbar.wrap.scrollTop = 0
    },
    /**
         * 重新初始化数组数据，根据搜索来源区分是全量替换还是增量追加
         * 每次加载新数据都会调用此方法
         * @param {Array} parray - 新获取的数据数组
         */
    reInitArray (parray) {
      // this.$alert(this.currentPage)
      // eslint-disable-next-line no-debugger
      debugger
      // 根据是否为新检索决定是清空重置还是增量合并数据
      if (this.newReSearch) { // 重新检索而来  而不是滚动条Loadmore
        this.rowsArray = []
        this.lastRow = []
        this.swImgsOnlyShowName = parray
        this.totalSwImgs = parray
      } else {
        this.totalSwImgs.push(...parray)
      }

      // 将合并后的全局搜索结果存入 Vuex，用于翻页等场景
      this.$store.commit('setGlobalSearchResult', this.totalSwImgs) // 在翻页的时候用
      // this.$store.state.globalObj.swImgs

      // 若新数据有效，则重置加载状态以允许继续加载更多
      if (parray != null && parray.length > 0) {
        this.isLoading = false // 重置状态 可继续加载数据
      }
    },
    /**
     * 根据关键词, 搜索类型名, 当前页数, 每页大小
     * 隐藏参数: 回退数量
     * 获取对应原始数据, 之后按木桶需要的数据结构整理数据
     * 最后调用reInitArray()方法展示数据到页面
     */
    searchImages (keyWord, typeClass, pageNo, pageSize) {
      // console.log('查询一次')
      this.lastRow = [] // 清空上次检索最后一行
      if ((typeClass != null && typeClass.length < 1) || typeClass === 'all') {
        this.typeName = '全部'
        typeClass = ''
      } else {
        this.typeName = typeClass
      }
      this.currentPage = pageNo // 设置当前页码
      const api = '/md/front/paid/image/multiSearch'
      const params = {
        kword: keyWord,
        itype: typeClass,
        pageSize: pageSize,
        pageNo: pageNo,
        rebackCount: this.rebackCount
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status !== 200) {
          return
        }
        res = res.data
        const resMap = res
        if (resMap.flag) {
          if (resMap.data != null) {
            this.isNoResult = false
            this.swImgs = resMap.data

            const rsCount = resMap.total
            this.totalitems = rsCount
            const count = rsCount % this.pageSize
            if (count === 0) {
              this.totalPages = rsCount / this.pageSize
            } else {
              this.totalPages = Math.floor(rsCount / this.pageSize) + 1
            }

            this.searchRsCount = rsCount
            // 显示当前检索的结果数
            this.reInitArray(resMap.data)
          } else {
            this.searchRsCount = 0
            this.isNoResult = true
            this.swImgs = []
            this.totalitems = resMap.total
          }
        } else {
          this.$alert(resMap.info, '提示')
        }
      })
      // alert('开始检索了：' + value)
    },
    /**
     * 从其他页面跳转到本页面的时候调用此方法
     * 前置条件:
     * // 搜素类型
     * // 搜索关键字
     * 根据本地数据获取前两个参数, 并尝试请求第一页的数据
     *
     */
    jump2Search () {
      debugger
      const stype = this.$store.state.globalObj.searchType
      const skey = this.$store.state.globalObj.searchKeyWords
      if (stype != null && stype.length > 0) {
        this.typeClass = stype
      }
      if (skey != null && skey.length > 0) {
        this.searchKey = skey
      }
      this.searchImages(this.searchKey, this.typeClass, 1, this.pageSize)
    }
  },
  computed: {
    singleBoxEvent () {
      return this.$store.state.events.singleBoxState
    }
  },
  watch: {
    singleBoxEvent () {
      const searchWord = this.$store.state.globalObj.searchKeyWords
      const searchType = this.$store.state.globalObj.searchType
      // 重新检索 清空原来的数据
      this.rowsArray = []
      this.swImgs = []
      this.newReSearch = true // 告诉处理结果函数这是新的请求  需要清掉之前的缓存
      this.rebackCount = 0
      if (typeof this.$refs.myScrollbar !== 'undefined') {
        if (this.$refs.myScrollbar.wrap !== null) {
          this.$refs.myScrollbar.wrap.scrollTop = 0 // 把滚动条调到顶部
        }
      }
      // 保存下检索字符串  翻页用
      this.$emit('beginSearch', true) // 把检索结果面板置顶 免得从收藏界面检索 显示不出来
      this.searchKey = searchWord
      if (searchType == null || searchType.length < 1) {
        this.typeClass = ''
      } else {
        this.typeClass = searchType
      }
      // this.$alert(this.searchKey + '---------' + this.typeClass)
      this.searchImages(this.searchKey, this.typeClass, 1, this.pageSize)
    }
  },
  components: {
    imgbox: imgbox
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
#clumnPan {
  width: 100%;
  height: auto;
}

.i_box{
    width: 20%;
    padding: 10px;
}

.rowPan {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

#boxList li {
  list-style: none;
  /*   width: 150px; */
  float: left;
  padding: 10px 5px;
}

#lineList li {
  list-style: none;
  width: 280px;
  float: left;
  padding: 15px 5px 15px 1px;
  text-align: left;
}

#imgBoxList {
  position: relative; /*和子元素 el-scrollbar 联动  如果没有bar元素  可以不要这个属性*/
  overflow: hidden;
  width: 100%;
  height: calc(100vh - 180px);
}
#imgBoxList .el-scrollbar {
  position: fixed; /* 只有这个和父窗口设置好position 才会 立马显示滚动条 不然的话只有在调试的时候手工修改下高度才会显出来  很奇怪*/
  height: calc(100vh - 180px);
  padding-right: 10px;
}

#imgBoxList .el-scrollbar__thumb {
  background-color: #fff;
}
#resInfo {
  font-size: 20px;
  text-align: center;
  position: relative;
  vertical-align: middle;
  margin-top: 100px;
  color: #fff;
}

#sbar {
  width: 80%;
}

.vue-barrel {
  padding: 10px 15px;
  display: inline-block;
  background-color: #367c77;
  color: #fff;
  margin: 0 0 10px 10px;
  box-sizing: inherit;
}

.main1 {
  width: 1200px;
  margin: 0 auto;
  text-align: left;
  overflow: hidden;
}

#typeCanvas {
  display: flex;
  flex-direction: row;
}

#typename {
  width: 20%;
  font-size: 25px;
  color: #fff;
  text-align: left;
  padding-left: 10px;
}
#searchRsCount {
  width: 80%;
  font-size: 20px;
  color: #fff;
  text-align: right;
  padding-right: 100px;
  line-height: 40px;
}
</style>
